// extracted by mini-css-extract-plugin
export default {"login":"LogIn_login__ZPVW6","logo":"LogIn_logo__oKkJC","separator":"LogIn_separator__sm+v9"};